import { Box } from '@material-ui/core';
import useLandingChart from '../../../../hooks/useLandingChart';
import { getColor } from '../../common/helpers';
import { userroles } from '../../../constants';
import PercentChart from '../PercentChart';
import { useNavigate } from 'react-router-dom';

function PercentTodayBox({
  isRTL,
  theme,
  color,
  systemcolor,
  height,
  employeeId = null,
  isEmployee = false,
}) {
  const { todayEvents } = useLandingChart(employeeId);
  const clr = getColor({ theme, color, systemcolor });
  const navigate = useNavigate();

  return (
    <Box
      style={{ cursor: 'pointer' }}
      onClick={() => navigate('/appointments')}
    >
      {(isEmployee || (todayEvents && userroles?.operations?.edit)) && (
        <PercentChart
          pricolor={theme.palette.primary.main}
          seccolor={theme.palette.secondary.main}
          data={todayEvents || []}
          height={height}
          color={clr}
          isRTL={isRTL}
        />
      )}
    </Box>
  );
}

export default PercentTodayBox;
